/** The yes/no answer a read-only surface renders for a boolean fact -- a clear-title flag, a homestead exemption, a
 * showings-enabled toggle, a referral-partner flag. ONE copy decision: a brand audit that moves to 'Y'/'N' or to
 * 'Included'/'Not included' lands here instead of at every ternary, where the drift shows up as one surface answering
 * differently from its neighbour about the same field.
 *
 * Deliberately NOT merged with `EMPTY_STATE_PLACEHOLDERS`: those answer "there is no value", this answers "the value is
 * false". A flag that is absent renders a placeholder; a flag that is `false` renders `NO`.
 */

export const BOOLEAN_DISPLAY = {
	YES: 'Yes',
	NO: 'No',
} as const;

/** @runtime-derived-ssot-helper (const-leaf-pinned): the runtime-deriving surface of the same-leaf
 * {@link BOOLEAN_DISPLAY} record -- a function only because the flag is a runtime value, so a brand audit that moves
 * to 'Y'/'N' retargets both the record and every render through it in one edit.
 *
 * Renders the yes/no answer for an already-decided boolean.
 *
 * The parameter is a BOOLEAN, never the raw column: the callsites disagree about what truthy means -- some read a real
 * `boolean`, others a D1 0/1 integer they compare with `=== 1`, and one distinguishes `null` (render nothing) from `0`
 * (render 'No'). Folding those predicates in would silently change what a `2` or a `null` renders, so the predicate
 * stays at the callsite and only the COPY is shared.
 */
export function formatYesNo(flag: boolean): string {
	return flag ? BOOLEAN_DISPLAY.YES : BOOLEAN_DISPLAY.NO;
}
